import DownLoadApp from './DownLoadApp'
export default DownLoadApp